// Item definitions. One item slot per champion.

export type ItemId =
  | "blueBuff"
  | "bfSword"
  | "largeRod"
  | "warmogsArmor"
  | "giantsBelt"
  | "executioners"
  | "locket"
  | "banshees"
  | "randuins"
  | "vampiricScepter";

export interface ItemDef {
  id: ItemId;
  name: string;
  description: string;
  // Stat multipliers applied in effectiveStats
  hpMult?: number;
  adMult?: number;
  apMult?: number;
  /** < 1 = CDR. Baked into def.abilityCooldown at unit build time. */
  cooldownMult?: number;
  // Special combat effects (handled in engine / action resolver)
  warmogRegen?: number;        // HP regen % per second
  antiHealOnHit?: number;      // heal reduction applied to target on hit (0..1)
  locketShieldPct?: number;    // shield % of holder's max HP at combat start, shared with adjacent allies
  banshee?: boolean;           // blocks the first enemy ability that would hit the holder
  randuinReduction?: number;   // fraction of auto-attack damage reduced (0..1)
  omnivamp?: number;           // fraction of all damage dealt returned as HP to the source
  ddragonItemId?: number | string;
}

export const ITEMS: Record<ItemId, ItemDef> = {
  blueBuff: {
    id: "blueBuff",
    name: "Blue Buff",
    description: "25% cooldown reduction.",
    cooldownMult: 0.75,
    ddragonItemId: 3040,
  },
  bfSword: {
    id: "bfSword",
    name: "B.F. Sword",
    description: "25% more AD.",
    adMult: 1.25,
    ddragonItemId: 1038,
  },
  largeRod: {
    id: "largeRod",
    name: "Needlessly Large Rod",
    description: "25% more AP.",
    apMult: 1.25,
    ddragonItemId: 1058,
  },
  warmogsArmor: {
    id: "warmogsArmor",
    name: "Warmog's Armor",
    description: "10% more HP. Regenerates 2% max HP per second.",
    hpMult: 1.10,
    warmogRegen: 0.02,
    ddragonItemId: 3083,
  },
  giantsBelt: {
    id: "giantsBelt",
    name: "Giant's Belt",
    description: "25% more HP.",
    hpMult: 1.25,
    ddragonItemId: 1011,
  },
  executioners: {
    id: "executioners",
    name: "Executioner's Calling",
    description: "Attacks apply 40% anti-heal to the target for 3 seconds.",
    antiHealOnHit: 0.40,
    ddragonItemId: 3123,
  },
  locket: {
    id: "locket",
    name: "Locket of the Iron Solari",
    description: "At combat start, grants a 15% max HP shield to the holder and adjacent allies.",
    locketShieldPct: 0.15,
    ddragonItemId: 3190,
  },
  banshees: {
    id: "banshees",
    name: "Banshee's Veil",
    description: "Blocks the first enemy ability that hits the holder.",
    banshee: true,
    ddragonItemId: 3102,
  },
  randuins: {
    id: "randuins",
    name: "Randuin's Omen",
    description: "Reduces damage taken from auto attacks by 35%.",
    randuinReduction: 0.35,
    ddragonItemId: 3143,
  },
  vampiricScepter: {
    id: "vampiricScepter",
    name: "Vampiric Scepter",
    description: "20% Omnivamp — heals for 20% of all damage dealt.",
    omnivamp: 0.20,
    ddragonItemId: 1053,
  },
};

export const ITEM_SLOTS_PER_UNIT = 1;
